import { timeZoneLabel } from 'fym-shared/src/music24/timeZones';

export interface TimeZoneOption {
  zone: string;
  /** `Europe/Warsaw · UTC+2` */
  label: string;
}

/** The text a search compares: the zone name with spaces for `/` and `_`, in lower case. */
function searchText(zone: string): string {
  return zone.replace(/[/_]/g, ' ').toLowerCase();
}

/**
 * The zones that match the search (every word of it, in any order), with their labels. The picked
 * zone always stays in the list, so the select never shows a value it has no option for. Pure.
 */
export function filterTimeZones(
  zones: readonly string[],
  query: string,
  picked: string,
  at: Date
): { options: TimeZoneOption[]; matchCount: number } {
  const words = query.trim().toLowerCase().replace(/[/_]/g, ' ').split(/\s+/).filter(Boolean);
  const matches = zones.filter((zone) => {
    const text = searchText(zone);
    return words.every((word) => text.includes(word));
  });
  const list = matches.includes(picked) || picked === '' ? matches : [picked, ...matches];
  return { options: list.map((zone) => ({ zone, label: timeZoneLabel(zone, at) })), matchCount: matches.length };
}
